import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Alert, Box, LinearProgress } from '@mui/material';
import { getStoredLoginMenus } from 'utils/menuConfig';

const ReportFrame = ({ url, title }) => {
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);
  return (
    <Box sx={{ position: 'relative', width: '100%', height: '100%', minHeight: 0, overflow: 'hidden', bgcolor: '#f5f7fb' }}>
      {loading && <LinearProgress aria-label="Loading report" sx={{ position: 'absolute', top: 0, width: '100%' }} />}
      {failed && <Alert severity="error">Unable to load this report. Please try again.</Alert>}
      <iframe
        src={url}
        title={title}
        sandbox="allow-scripts allow-same-origin allow-forms allow-downloads"
        referrerPolicy="same-origin"
        allow="camera 'none'; microphone 'none'; geolocation 'none'"
        onLoad={() => setLoading(false)}
        onError={() => { setLoading(false); setFailed(true); }}
        style={{ display: 'block', width: '100%', height: '100%', border: 0, background: '#f5f7fb' }}
      />
    </Box>
  );
};

const ReportViewer = () => {
  const { state } = useLocation();
  const reportId = state?.reportId;
  const menus = getStoredLoginMenus();
  const report = Array.isArray(menus) ? menus.find((menu) =>
    String(menu.menuId ?? menu.menuSlug ?? '') === reportId &&
    typeof menu.pythonServiceUrl === 'string' && menu.pythonServiceUrl.trim()) : null;

  if (!report) return <Alert severity="warning">Report not available for your account.</Alert>;

  let url;
  try {
    url = new URL(report.pythonServiceUrl.trim(), window.location.origin);
    if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password ||
        (window.location.protocol === 'https:' && url.protocol !== 'https:')) throw new Error('Invalid report URL');
  } catch {
    return <Alert severity="error">The report URL is invalid. Please contact your administrator.</Alert>;
  }

  return <ReportFrame key={`${reportId}:${url.href}`} url={url.href} title={report.menuName || 'Report'} />;
};

export default ReportViewer;
